<template>
<div class="cetin-data">
  <span v-if="loading || (results && results.tariffs && results.tariffs.length)" class="company-name"> Nordic: </span>
		<div v-if="loading">
			<tile :loading="loading" :height="'4'" :width="'4'" class="loading-icon"></tile>
		</div>
	<div

		v-if="results && results.tariffs && results.tariffs.length"
	>
		<div
			v-for="(tarif, index) in processTariffs(results.tariffs)"
			:key="index"
			class="cetin-vysledek d-none d-md-flex "
			style="flex-direction: column;"
		>
			<!-- {{ tarif }} -->
			<span style="font-size: 22px; font-weight: bold; color: gray; margin-top: 5px; margin-bottom: 10px">
				{{ index }}
			</span>

			<div style="display: flex; flex-direction: row; flex-wrap: wrap;">
				<div
					v-for="t of tarif"
					class="cetin-vysledek-card"
					style="display: flex; flex-direction: column; flex-wrap: wrap;"
					:key="t.tariff"
				>
					<div>
						<span>
							Tarif:
							<span style="font-weight: bold;">
								{{ t.name }}
							</span>
						</span>
					</div>
					<div>
						<span v-if="t.download">
							Down:
							{{ t.download }} Mbps
						</span>
					</div>
					<div>
						<span v-if="t.upload">
							Up:
						  {{ t.upload }} Mbps
						</span>
					</div>
					<div>
						<span v-if="t.real_download_on_address">
							Max Down:
							{{
								t.real_download_on_address
							}}
							Mbps
						</span>
					</div>
					<div>
						<span v-if="t.real_upload_on_address">
							Max Up:
							{{ t.real_upload_on_address }}
							Mbps
						</span>
					</div>
					<div>
						<span> Cena: {{ t.price }}Kč </span>
					</div>
          <div>
            <span v-if="t.price_with_discount"> Cena se slevou: {{ t.price_with_discount }}Kč </span>
          </div>
					<div>
						<span> Technologie: {{ t.technology }} </span>
					</div>
					<div>
						<span v-if="t.device_price">
							Cena zařízení: {{ t.device_price }} Kč
						</span>
					</div>
					<div

						v-if="t.installation_price"
					>
						<span>
							Cena instalace: {{ t.installation_price }} Kč
						</span>
					</div>
				</div>
			</div>
		</div>
		<div class="d-md-none cetin-vysledek cetin-vysledek-card-mobile"
			v-for="(tarif, index) in results.tariffs"
			:key="index"
		>
			<div>
				<span>
					Tarif:
					<span style="font-weight: bold;">
						{{ tarif.name }}
					</span>
				</span>
			</div>
			<div>
				<span v-if="tarif.download">
					Down:
					{{ tarif.download }} Mbps
					<!-- {{ (parseInt(tarif.download) / 1024).toFixed(1) }} Mbps -->
				</span>
			</div>
			<div>
				<span v-if="tarif.upload">
					Up:
					{{ tarif.upload }} Mbps
					<!-- {{ (parseInt(tarif.upload) / 1024).toFixed(1) }} Mbps -->
				</span>
			</div>
			<div>
				<span v-if="tarif.real_download_on_address">
					Real Down:
					{{ tarif.real_download_on_address }}
					Mbps
				</span>
			</div>
			<div>
				<span v-if="tarif.real_upload_on_address">
					Real Up:
					{{ tarif.real_upload_on_address }}
					Mbps
				</span>
			</div>
			<div>
				<span> Cena: {{ tarif.price }}Kč </span>
			</div>
      <div>
				<span v-if="tarif.price_with_discount"> Cena se slevou: {{ tarif.price_with_discount }}Kč </span>
			</div>
			<div>
				<span> Technologie: {{ tarif.technology }} </span>
			</div>
			<div>
				<span v-if="tarif.device_price">
					Cena zařízení: {{ tarif.device_price }} Kč
				</span>
			</div>
			<!-- <div>
				<span>
					Cena pronájmu zařízení: {{ tarif.device_price_rent }} Kč
				</span>
			</div> -->
			<div v-if="tarif.installation_price">
				<span>
					Cena instalace: {{ tarif.installation_price }} Kč
				</span>
			</div>
		</div>
	</div>
  </div>
</template>

<script>
export default {
	name: 'NordicResult',

	props: {
		results: { type: Object, default: {} },
		loading: { type: Boolean }
	},

	methods: {
		processTariffs(tariffs) {
			if (tariffs.length < 1) {
				return {};
			}

			const newTariffs = {};

			for (const o of tariffs) {
				if (newTariffs.hasOwnProperty(o.technology)) {
					newTariffs[o.technology].push(o);
				} else {
					newTariffs[o.technology] = [o];
				}
			}

			return newTariffs;
		}
	}


}
</script>

<style lang="stylus" scoped>
.cetin-data
    padding-top 10px
    margin-top 15px
    border-bottom 1px solid #4CA5F9
    border-top 1px solid #4CA5F9

.company-name
    font-weight bold
    font-size 24px

.cetin-vysledek
    display flex
    flex-direction column
    border-bottom 1px dashed #4CA5F9
    border-top 1px dashed #4CA5F9

.cetin-vysledek-card
    padding 10px
    background-color white
    border-radius 5px
    margin-right 10px
    margin-bottom 10px

.cetin-vysledek-card-mobile
    padding 10px
    background-color white
    border-radius 5px
    margin-top 5px

.loading
	height 50px
	padding 0px

.loading-icon
	height 50px
	padding 0px !important
	margin-top -100px !important


</style>



// WEBPACK FOOTER //
// src/components/search_provider/results/NordicResult.vue